export default {
      id: "top-menu-telerehab-up-usage",
      viewBox: "0 0 28 16",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#top-menu-telerehab-up",
      toString: function () {
        return this.url;
      }
    }